<template>
  <div class="mt-3 grid gap-5 grid-cols-6 animate-pulse mb-5" v-for="row in rows" :key="row">
    <div class="col-span-2 flex shadow-sm h-5 bg-gray-200 rounded w-full"/>
    <div class="col-span-3 flex shadow-sm h-5 bg-gray-200 rounded w-full"/>
    <div class="col-span-1 flex shadow-sm h-5 bg-gray-200 rounded w-full"/>
  </div>
</template>

<script>
export default {
  name: "UiTablePlaceholder",
  props: {
    rows: {
      default: 10,
    }
  }

}
</script>

<style scoped>

</style>